import { DsbcApiOptions } from '../_dsapi/DsbcApiOptions';
import { createDsbcApiUrl } from '../createDsbcApiUrl';
import { DsbcApi } from '../createDsbcRequest';
import { BaseResponse } from '../shared';

interface getInvCodeRequest {
  uid: string; //主邀人UID
}

export interface getInvCodeData {
  invCode?: string; //邀请码
}

interface getInvCodeResponse extends BaseResponse {
  Data: getInvCodeData;
}

/**
 * 获取邀请码
 * @param params
 * @returns
 */
export async function getInvCode(request: getInvCodeRequest, options?: DsbcApiOptions) {
  const url = await createDsbcApiUrl('/inv/getInvCode');
  return DsbcApi.fetch<getInvCodeResponse>(url, request, false, options);
}
